module.exports = __webpack_public_path__ + "static/media/3-excursions.148144c5.jpg";